module.exports = __webpack_public_path__ + "img/across shoulder.e94b8916.png";